export default __webpack_public_path__ + "static/media/clem-onojegaw.8809fc53.jpg";